import request from "@/utils/request";
import { createStaticResult, getMilestones } from "@/data/siteContent";

export function artMilestone() {
  return createStaticResult(getMilestones());
}

export function artFeedBack(params) {
  const contact = [params.phone, params.email].filter(Boolean).join(" / ");
  const content = [params.content, params.name ? `留言人：${params.name}` : ""]
    .filter(Boolean)
    .join("\n");

  return request.post(
    "/feedBack/submit",
    {
      categoryId: 1,
      courseId: 0,
      title: params.title,
      content,
      imageUrl: "",
      contact,
    },
    { login: true }
  );
}
